// АН 2026 11 03 / ODOO-350881 (инвентаризация помощи, этапы 1 и 3; поручение владельца, шина #126117: «Вопрос в заголовке окон, который открывает помощь
// есть мало на каких окнах… Для чего эта форма, что она позволяет сделать или проконтроллировать. И далее стандартные описания, что это например отчет
// и ссылка на работу с отчетом а также нужно будет сделать ссылку на работу с навигатором»): КАРТОЧКА ПОМОЩИ ОКНА.
// «?» в шапке каждого окна (Widget.vue: отчёт, список, график и граф, форма, задача, источник данных) и в шапке приложения (AppTopbar: страница и её
// рабочая область) открывает карточку (components/HelpCard.vue):
//   1) описание окна — метод бэка record_help (RECORD-HELP базы → реестр кода → текст записи): «Для чего» (what, why), «Что можно сделать или
//      проконтролировать» (how, строка = пункт). Ключ — сама запись окна (вариант без своего описания — основная настройка, как подсказка по Alt);
//   2) блок типа (решение ie-webscm7-2 03.11) — тот же record_help по записи SEGMENTS сегмента объекта окна, SEGMENTS|<сегмент> (тексты — реестр кода бэка
//      addons/ADDON_core/record_help/config_kinds.json, запись на каждый сегмент семейства; правка — RECORD-HELP базы); у сегмента без текста (форма записи
//      данных: сегмент — любой сегмент базы; новый тип задачи) — первый сегмент семейства (HELP_TYPES.segment). Ссылки на руководство пользователя
//      docs/user-guide — здесь: record_help отдаёт только тексты;
//   3) статья окна — doc_link сегмента из кнопки «?» бэка (widget-docs), если она не совпала со ссылкой блока и не архив разработчика (_archive/:
//      база до пересева этапа 0); навигатор — команда navigator_open, если навигатор включён (статьи о навигаторе в руководстве нет).
// Флаг fe.ux.helpCard (настройка базы, по умолчанию ВЫКЛ): выключен — прежний «?» бэка (только у сегментов со ссылкой doc_link), компонента,
// кнопок и запросов карточки нет. Без DOM и сети — tests/unit/helpCard.test.mjs.
export const HELP_CARD_FLAG = 'fe.ux.helpCard'
export const helpCard_on = (store) => { try { return !!store && typeof store.setting === 'function' && store.setting(HELP_CARD_FLAG, false) === true } catch (e) { return false } }

const UG = 'docs/user-guide/'
// тип окна → первый сегмент семейства (запасной ключ блока SEGMENTS|<segment>), заголовок блока и название типа (ключи словаря), статьи руководства о работе с этим типом
export const HELP_TYPES = {
    report: { segment: 'WIDGET-REPORT2', title: 'This is a report', name: 'Report', links: [UG + 'tables.md', UG + 'cell-details.md'] },
    list: { segment: 'WIDGET-LIST', title: 'This is a list', name: 'List', links: [UG + 'lists.md', UG + 'chips.md'] },
    chart: { segment: 'WIDGET-DS', title: 'This is a chart or a graph', name: 'Chart or graph', links: [UG + 'charts-maps-gantt.md'] },
    form: { segment: 'WIDGET-RECORD', title: 'This is a form', name: 'Form', links: [UG + 'lists.md'] },
    page: { segment: 'PAGE', title: 'This is a page', name: 'Page', links: [UG + 'workspaces-and-pages.md'] },
    workspace: { segment: 'WORKSPACE', title: 'This is a workspace', name: 'Workspace', links: [UG + 'workspaces-and-pages.md'] },
    task: { segment: 'TASKS', title: 'This is a task', name: 'Task', links: [UG + 'tasks.md'] },
    ds: { segment: 'DATA-SOURCE', title: 'This is a data source', name: 'Data source', links: [UG + 'lists.md'] },
    docs: { segment: 'WIDGET-DOCS', title: 'This is a guide', name: 'Guide', links: [UG + 'help.md'] },   // АН 2026 11 03 / ODOO-350881: читалки руководства (widget-docs-instr-*, widget-docs) — не форма
}
// подписи статей — их заголовки H1 (ключи словаря: английский заголовок страницы, переводы — заголовки её uk / ru)
export const HELP_ARTICLES = {
    [UG + 'tables.md']: 'Reports and tables: expanding, periods, export',
    [UG + 'cell-details.md']: 'Where a number comes from: the cell passport',
    [UG + 'lists.md']: 'Lists and record cards',
    [UG + 'chips.md']: 'Chips: filtering the data',
    [UG + 'charts-maps-gantt.md']: 'Charts, map and Gantt',
    [UG + 'tasks.md']: 'Tasks and calculations',
    [UG + 'workspaces-and-pages.md']: 'Workspaces and pages',
    [UG + 'dynamic-lists.md']: 'Dynamic lists',
    [UG + 'sign-in.md']: 'Signing in and choosing a database',
    [UG + 'help.md']: 'Help in the interface and keyboard shortcuts',   // АН 2026 11 03 / ODOO-350881: статья блока окон руководства (раздел «Open the documentation of a widget»)
}
const SEG = 'SEGMENTS'

// тип окна по сегменту его записи (пары object_type × segment инвентаризации 350881 — фикстура теста); прочее — форма
export function helpCard_type(segment) {
    const s = String(segment || '')
    if (s === 'PAGE') return 'page'
    if (/^WORKSPACE(-|$)/.test(s)) return 'workspace'
    if (/^TASKS(-|$)/.test(s) || s === 'CALC-CASCADE' || s === 'TEST-DATA') return 'task'
    if (/^DATA-SOURCE(-|$)/.test(s)) return 'ds'
    if (/^WIDGET-(REPORT|PIVOT_TOOL)/i.test(s)) return 'report'
    if (/^WIDGET-LIST/i.test(s) || /^WIDGET-.*List$/.test(s) || ['WIDGET-logs', 'WIDGET-TREE', 'WIDGET-catalogs'].includes(s)) return 'list'
    if (s === 'WIDGET-DS' || s === 'WIDGET-Gantt') return 'chart'
    if (s === 'WIDGET-DOCS') return 'docs'   // АН 2026 11 03 / ODOO-350881: окна руководства — свой блок, не «Это форма»
    return 'form'
}

// ключи блока типа: запись SEGMENTS сегмента объекта, затем первого сегмента семейства (порядок = приоритет)
export function helpCard_typeKeys(segment, type = 'form') {
    const keys = [String(segment ?? ''), (HELP_TYPES[type] || HELP_TYPES.form).segment].filter(Boolean).map(s => `${SEG}|${s}`)
    return [...new Set(keys)]
}

// элементы запроса record_help: запись окна, основная настройка варианта, ключи блока типа
export function helpCard_items(target = {}, type = 'form') {
    const id = String(target.id ?? ''), segment = String(target.segment ?? ''), mainId = String(target.mainId ?? '')
    const items = []
    const push = (it) => { if (!items.some(x => x.id === it.id && x.segment === it.segment)) items.push(it) }
    if (id) push({ id, segment })
    if (mainId && mainId !== id) push({ id: mainId, segment })
    for (const k of helpCard_typeKeys(segment, type)) push({ id: k.slice(SEG.length + 1), segment: SEG })
    return items
}

// ссылка без схемы docs: и без ведущего ./ (как хранит doc.doc_link); путь — без #якоря
const linkNorm = (link) => { let s = String(link || '').trim(); if (s.slice(0, 5).toLowerCase() === 'docs:') s = s.slice(5).trim(); while (s.startsWith('./')) s = s.slice(2); return s }
const linkPath = (link) => linkNorm(link).split('#')[0]

// статья окна: ссылка кнопки «?» бэка, если её ещё нет среди ссылок блока типа и это не архив разработчика (_archive/ — база до пересева этапа 0)
export function helpCard_article(docLink, typeLinks = []) {
    const link = linkNorm(docLink), path = linkPath(link)
    if (!path || path.startsWith('_archive/') || !path.endsWith('.md')) return ''
    return (typeLinks || []).some(l => linkPath(l) === path) ? '' : link
}

// «?» бэка — кнопка виджета документации (widgets.set_menu): при включённом флаге её место занимает «?» карточки
export const helpCard_isDocsButton = (cmd) => !!cmd && cmd.command === 'widget_open' && cmd.widget === 'widget-docs'

// кнопка «?» карточки в командной панели виджета — один объект на виджет (панель обновляется на месте по id), как кнопка Σ
export function helpCard_button(prev, tr = (s) => s) {
    const b = prev || { attr_type: 'AttrButton', command: 'executeVueObjMethod', method: 'helpCard_open', front_only: true, name: 'help-card', showCommandTitle: false, _key: 'Help' }
    b.cssClass = 'pi p-button-white p-button-text0 pi-question-circle'
    b.title = tr('Help')
    b.tooltip = tr('Help: what this window is for and how to work with it')
    b.uiHelp = 'widget.header.btn.help'
    return b
}

const lines = (v) => String(v ?? '').split(/\n+/).map(s => s.trim()).filter(Boolean)
const hasText = (e) => !!e && typeof e === 'object' && ['what', 'why', 'how'].some(f => String(e[f] ?? '').trim())

// содержимое карточки: map — ответ record_help ({'<segment>|<id>': запись | null}), items — запрос (порядок = приоритет), segment — сегмент объекта окна, tr — словарь.
// → { typeName, purpose: [абзацы], how: [пункты], typeTitle, typeText, links: [{ link, label }], article: { link, label } | null, source }
export function helpCard_model({ map = {}, items = [], type = 'form', segment = '', docLink = '', tr = (s) => s } = {}) {
    const T = HELP_TYPES[type] || HELP_TYPES.form
    const typeKeys = helpCard_typeKeys(segment, type)
    const own = items.map(it => `${it.segment}|${it.id}`).filter(k => !typeKeys.includes(k)).map(k => map && map[k]).find(hasText) || null
    const kind = typeKeys.map(k => map && map[k]).find(e => !!e && typeof e === 'object' && String(e.what ?? '').trim()) || null
    const label = (link) => tr(HELP_ARTICLES[linkPath(link)] || linkPath(link).split('/').pop().replace(/\.md$/, ''))
    const article = helpCard_article(docLink, T.links)
    return {
        typeName: tr(T.name),
        purpose: own ? [...lines(own.what), ...lines(own.why)] : [],
        how: own ? lines(own.how) : [],
        source: own ? String(own.source || '') : '',
        typeTitle: tr(T.title),
        typeText: kind ? lines(kind.what).join(' ') : '',
        links: T.links.map(link => ({ link, label: label(link) })),
        article: article ? { link: article, label: label(article) } : null,
    }
}

// единственная карточка приложения (HelpCard.vue регистрируется сама); opts — { anchor, vueObj, title, id, segment, mainId, docLink, type?, tabs? }
export const helpCard = { card: null }
export function helpCard_show(opts) {
    const c = helpCard.card
    if (!c || typeof c.open !== 'function') return false
    return c.open(opts || {}) !== false
}
